/**
 * Human-looking handles for bots / CPU rivals (offline roster, leaderboard filler, fallbacks).
 * Kept deterministic via {@link npcUsernameForSeed}.
 */
export const NPC_DISPLAY_NAMES: readonly string[] = [
  "TriviaTiger99",
  "neonNoodle",
  "factHunter42",
  "waffleWizard_",
  "PixelPuma",
  "QuizPilot07",
  "mapleMavenxo",
  "retroRaccoon",
  "lunarLoot",
  "byteBard",
  "zestyZebra22",
  "cosmoCrumpet",
  "NovaKnack",
  "dingoDoodle",
  "emberOtter",
  "icedInkling",
  "velvetVolt88",
  "glitchGremlin",
  "sapphireSnail",
  "turboTapir",
  "mochaMantis",
  "paperPlanePro",
  "ridgeRiddler",
  "opalOcelot",
  "frostFoxtrot",
  "civicCapybara",
  "bubblegumBolt",
  "harborHopper",
  "echoEclair",
  "prismPelican",
  "siloSloth",
  "tangeloToad",
  "quasarQuokka",
  "riftRaven",
  "sundaeSprite",
  "twilightTetra",
  "urbanUrchin",
  "voxelViper",
  "wispWalrus",
  "yardYuzu",
  "zenZephyrxo",
  "amberAxolotl",
  "blueprintBee",
  "cinderCricket",
  "docksideDove",
  "emberEraser",
  "fjordFinch",
  "gizmoGibbon",
  "harvestHippo",
  "isleImpala",
  "jigsawJackal",
  "kioskKiwi",
  "lagoonLlama92",
  "mintMacaw",
  "nimbusNewt",
  "orchidOrca",
  "paddockPenguin",
  "quartzQuail",
  "reefRocket",
  "summitShrimp",
  "tundraTamarin",
  "upbeatUguisu",
  "vistaViperfish",
  "wonderWarbler",
  "xenonXerus",
  "yarnYabby",
  "zipZorse",
  "afterglowAkita",
  "basilBonobo",
  "coralCourier",
  "deltaDingo",
  "emberEnvelope",
  "folioFerret",
  "groveGator",
  "horizonHatchet",
  "indigoIbex47",
  "jadeJackrabbit",
  "kelpKoala",
  "lagoonLadybug",
  "marinaMandrill",
  "niftyNarwhal",
  "olmOsprey",
  "prairiePossum",
  "quinoaQuetzal",
  "reefRobin",
  "sableSeal",
  "timberTanuki72",
  "umbraUrchinxo",
  "vegaVicuna",
  "willowWalleye",
  "xericXray",
  "yardbirdYak",
  "zeroZebu",
  "altitudeAlpaca",
  "bluffBadgerxo",
  "cinderCatfish",
  "driftDalmatian",
  "edenEagleRay",
  "flintFlamingo51",
  "ghostGazellexo",
  "hollowHedgehog",
];

function hashSeed(s: string): number {
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

/** Stable pick from {@link NPC_DISPLAY_NAMES} so the same seed always yields the same handle. */
export function npcUsernameForSeed(seed: string): string {
  const idx = hashSeed(seed) % NPC_DISPLAY_NAMES.length;
  return NPC_DISPLAY_NAMES[idx]!;
}
